import type { UpdateLouvreCutoutsCommand } from "../../../commands/updateLouvreCutoutsCommand";
import type { UpdateWindowDesignParametersCommand } from "../../../commands/updateWindowDesignParametersCommand";
import type { IPanelGeneratedModelDto } from "../../../responses/panelGeneratedModelDto";
import type { ICategory } from "../../../responses/typesManagerCategories";
import type { CategoryType } from "../typesManager/constants/panelTypeEnums";

export type UpdatePanelTypeEventPayload = {
    id: string;
    name: string;
    withoutCladdings: boolean;
};

export type CreateNewPanelTypeEventPayload = UpdatePanelTypeEventPayload & {
    panelId: string;
};

export type PanelTypeSwitchedEventPayload = {
    panelId: string;
    targetPanelTypeId?: string;
    removedHooksDbIds: number[];
};

export type SwitchPanelTypeEventPayload = {
    panelId: string;
    targetTypeId: string;
};

export type PanelTypeSelectedEventPayload = {
    panelTypeId: string;
    panelCategory: CategoryType;
};

export type FitToViewEventPayload = {
    panelId: string;
    panelCategory: CategoryType;
};

export type GenerateAllStartedEventPayload = {
    panelTypeIds: string[];
    cornerTypeIds: string[];
};

export type GenerationResultEventPayload = {
    panels: IPanelGeneratedModelDto[];
    corners: IPanelGeneratedModelDto[];
};

export type TypesManagerRefreshEventPayload = {
    categories: ICategory[];
    selectedPanelId: string | null;
};

export type DrawingsLoadingStateEventPayload = {
    isLoading: boolean;
    panelTypeId: string;
};

export type UpdateWindowDesignParametersEventPayload = UpdateWindowDesignParametersCommand & {
    panelTypeId: string;
};

export type UpdateLouvreCutoutsEventPayload = {
    panelTypeId: string;
} & UpdateLouvreCutoutsCommand;

export enum TypesManagerGenerationFailureSourceEnum {
    SinglePanelTypeGeneration = "singlePanelTypeGeneration",
    SingleCornerTypeGeneration = "singleCornerTypeGeneration",
    EntireModelGeneration = "entireModelGeneration",
    ReceivingModel = "receivingModel",
}

export interface ITypesManagerStartGenerationFailurePayload {
    message: string;
    source: {
        id: string;
        type: TypesManagerGenerationFailureSourceEnum;
    };
}
